import React, { SVGProps } from 'react';

const DropdownArrowIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			{...props}
		>
			<g clipPath="url(#clip0_23452_164463)">
				<path
					d="M5.61216 9.10562L0.157888 3.65135C0.107213 3.60067 0.0670147 3.54051 0.0395899 3.4743C0.0121641 3.40809 -0.00195217 3.33712 -0.00195217 3.26546C-0.00195217 3.19379 0.0121641 3.12283 0.0395899 3.05661C0.0670147 2.9904 0.107213 2.93024 0.157888 2.87957C0.208564 2.82889 0.268725 2.78869 0.334936 2.76127C0.401147 2.73384 0.472112 2.71973 0.543778 2.71973C0.615444 2.71973 0.686409 2.73384 0.75262 2.76127C0.818831 2.78869 0.878992 2.82889 0.929667 2.87957L5.99805 7.94863L11.0664 2.87957C11.1688 2.77722 11.3076 2.71973 11.4523 2.71973C11.5971 2.71973 11.7359 2.77722 11.8382 2.87957C11.9406 2.98191 11.998 3.12072 11.998 3.26546C11.998 3.41019 11.9406 3.549 11.8382 3.65135L6.38394 9.10562C6.33328 9.15633 6.27313 9.19656 6.20691 9.22401C6.1407 9.25145 6.06973 9.26558 5.99805 9.26558C5.92637 9.26558 5.8554 9.25145 5.78918 9.22401C5.72297 9.19656 5.66281 9.15633 5.61216 9.10562Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_23452_164463">
					<rect
						width="12"
						height="12"
						fill="white"
						transform="matrix(0 1 -1 0 12 0)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default DropdownArrowIcon;
